<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>
    <ng-container *ngIf="consulta">
        <div class="body">
            <ng-container *ngFor="let r of consulta?.registros; let i = index">
                <h2 class="subtitle subtitle-{{status}}">REGISTRO {{i+1}}</h2>
                <ul class="card-list-striped py-1">
                    <li>
                        <span class="text-secondary">INFORMANTE:</span>
                        <span class="text-uppercase text-center">{{ r?.informante || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">TIPO:</span>
                        <span class="text-uppercase">{{ r?.tipo || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CIDADE:</span>
                        <span class="text-uppercase">{{ r?.cidade || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CONTRATO:</span>
                        <span class="text-uppercase">{{ r?.contrato || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">DÉBITO:</span>
                        <span class="text-uppercase">{{ r?.debito || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">DISPONÍVEL:</span>
                        <span class="text-uppercase">{{ r?.disponivel || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">VALOR:</span>
                        <span class="text-uppercase">{{ r?.valor || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">UF:</span>
                        <span class="text-uppercase">{{ r?.uf || msgNull }}</span>
                    </li>
                </ul>
            </ng-container>
        </div>
    </ng-container>
</app-card-consulta>